const DESTINATIONS = [
  {
    name: "London",
    src:
      "https://london.ac.uk/sites/default/files/styles/promo_large/public/2018-10/london-aerial-cityscape-river-thames_1.jpg?itok=BMaDUhjp",
    description:
      "One of the world’s most visited cities, England’s buzzing capital is well worth the visit and has so much to offer, from magnificent history and culture to cutting-edge fashion and food.",
    url: "https://www.visitlondon.com"
  },
  {
    name: "Glasgow",
    src: "https://media.timeout.com/images/105400989/750/422/image.jpg",
    description:
      "Voted one of the friendliest cities in the world, Scotland’s biggest city is a stylish mix of arts, culture and unique Celtic charm. Vibrant, edgy and brimming with personality, it's a must-see spot for art, culture and cuisine.",
    url: "https://www.peoplemakeglasgow.com"
  },
  {
    name: "Manchester",
    src:
      "https://d3sux4fmh2nu8u.cloudfront.net/Pictures/1024x536/3/4/3/1911343_piccadillygardens_687394.jpg",
    description:
      "Youthful, diverse, energetic and bursting with character; Manchester is one of the most exciting places to visit in the UK right now where everybody and anybody is very warmly welcomed.",
    url: "https://www.visitmanchester.com/"
  }
];

export default DESTINATIONS;
